import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Close from "./assets/Close.png";
import { disableEnableScroll } from "@tw/style-guide/lib/components/utilities/util";
import scss from "./popupConfirm.scss";
import Drawer from "../Drawer/Drawer";

const PopupConfirm = (props) => {
  const { showPopup, title, titleLine, children, okBtn, cancelBtn, showTextTemplate, autoDisable, styles } = props;

  useEffect(() => {
    //if (showPopup)
    if (autoDisable) {
      disableEnableScroll(showPopup);
      return () => {
        disableEnableScroll(false);
      };
    }
  }, [showPopup]);

  const onBackdropClick = () => {
    cancelBtn.action();
    document.body.style.overflowY = "auto";
    document.body.style.paddingRight = "inherit";
  };

  const handleClickInside = (e) => {
    e.stopPropagation();
  };

  const handleOkBtn = () => {
    okBtn.action();
  };
  const handleCancelBtn = () => {
    cancelBtn.action();
  };
  return (
    <Drawer
      variant="temporary"
      anchor="bottom"
      open={showPopup}
      ModalProps={{ onBackdropClick: () => onBackdropClick() }}
    >
      <div className={scss.confirm_container} onMouseDown={onBackdropClick}>
        <div
          style={styles}
          className={`${scss.body_container} ${showTextTemplate ? scss.txtTemplateContainer : ""}`}
          onMouseDown={handleClickInside}
        >
          <div className={scss.close_bar}>
            <button
              tabIndex="0"
              aria-label="Close"
              type="button"
              className={scss.close_button}
              onClick={handleCancelBtn}
            >
              <img src={Close} />
            </button>
            <button className={scss.close_notch} onClick={handleCancelBtn}></button>
          </div>
          <div className={`${showTextTemplate ? scss.txtTemplateFrame : ""}`}>
            <div className={`${scss.title} ${titleLine ? scss.withLine : ""}`}>{title}</div>
            <div className={`${scss.content}`}>{children}</div>
          </div>
          <div className={`${scss.buttonGroup} ${showTextTemplate ? scss.desktopHide : ""}`}>
            {cancelBtn.text && (
              <button className={scss.btnCancel} onClick={handleCancelBtn}>
                {cancelBtn.text}
              </button>
            )}
            {okBtn.text && (
              <button className={scss.btnOK} onClick={handleOkBtn}>
                {okBtn.text}
              </button>
            )}
          </div>
        </div>
      </div>
    </Drawer>
  );
};

PopupConfirm.defaultProps = {
  title: "",
  titleLine: false,
  okBtn: {
    text: "",
    action: () => {
      console.log("OK");
    },
  },
  cancelBtn: {
    text: "",
    action: () => {
      console.log("CANCEL");
    },
  },
  showPopup: false,
  showTextTemplate: false,
  autoDisable: true,
  styles: {},
};

PopupConfirm.propTypes = {
  title: PropTypes.string,
  titleLine: PropTypes.bool,
  okBtn: PropTypes.object,
  cancelBtn: PropTypes.object,
  showPopup: PropTypes.bool,
  showTextTemplate: PropTypes.bool, // for desktop only
  autoDisable: PropTypes.bool,
  styles: PropTypes.object,
};

export default PopupConfirm;

/* Sample

  const [showPopup, setShowPopup] = useState(true);
  const handleActionLogout = () => {
    console.log("OK")
    setShowPopup(false)
  }
  const handleActionCancel = () => {
    console.log("Cancel")
    setShowPopup(false)
  }

  <PopupConfirm 
    title='登出'
    showPopup={showPopup}
    okBtn={{
        text: '登出',
        action: handleActionLogout
    }}
    cancelBtn={{
        text: '取消',
        action: handleActionCancel
    }}
    >
        <span>您確定要退出嗎</span>
  </PopupConfirm>
*/
